<template>
  <div class="interaction boxs">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="interaction-head">人脸搜索</div>
      <div class="interaction-box">
        <img :src="base64" alt="" class="img"/>
        <div v-for="row in dataList">
          <div class="recognize-head">识别信息</div>
          <div class="recognize-box">
            <div class="recognize-img">
              <img :src="face.url" class="" v-for="face in row.faceImages"/>
            </div>
            <el-descriptions :column="2" border>
              <el-descriptions-item>
                <template slot="label">座位号</template>
                {{ row.seatNumber }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">姓名</template>
                {{ row.name }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">性别</template>
                {{ row.genderComment }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">年龄</template>
                <span style="font-weight: bold;">{{ row.age }}</span>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">身份证号</template>
                {{ row.idCard }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>

      </div>
      <div class="bt-box">
        <el-button class="bt2" @click="handleClose">取消</el-button>
        <el-button class="bt" type="primary" @click="search" :loading="loading">搜索</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {searchFaceByBase64} from "@/api/kecang";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    base64: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dataList: []
    }
  },
  methods: {
    checkNull(obj, attr) {
      return attr && obj && obj[attr] ? obj[attr] : ''
    },
    handleClose() {
      this.$emit('handle-close')
    },
    async search() {
      this.loading = true
      const result = await searchFaceByBase64(this.base64).finally(() => this.loading = false)
      if (result.code === 'A00000') {
        if (result.rowCount > 0) {
          this.dataList = result.data
        } else {
          this.dataList = null
          this.$message.error('人脸库未匹配到结果')
        }
      } else {
        this.dataList = null
        console.error(`人脸匹配失败：${result.message}`)
        this.$message.error('未识别到人脸')
      }
    }
  }

}
</script>


<style lang="less" scoped>
  .recognize-box{
    display: flex;
  }
  .recognize-head{
    line-height: 40px;
    text-align: center;
    margin-top: 15px;
    border-top:1px solid #2A4777;
  }
  .recognize-img{
    img{
      height: 125px;
    }
  }
.interaction-head{
    font-size: 16px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .img{
    width: 100%;
  }
  .bt-box{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    margin-top: 20px;
  }
  .interaction-box{
    padding: 0 20px;
  }
  .bt{
    margin: 0;
    border: none;
    width: calc(50% - 10px);
  }
  .bt2{
    border-radius: 8px;
    width: 258px;
    margin-right: 24px;
    height: 44px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/SearchFaceDialog.vue